(function ($) {
	/**************************
	 ** Paste From External **
	 **************************/
	var $a = function(){}
	RVwys.windowPasteFromExternal = function(isTour){
		var UI = UIkit;
		var onInsert = function(){
			var optionCleanHTML = [];
			$a=modal.element.find
			(modal.element.find('input#removeProprietary').prop('checked'))? optionCleanHTML.push(["removeProprietary",true]) :  optionCleanHTML.push(["removeProprietary",false]);
			(modal.element.find('input#removeSpecChar').prop('checked'))? optionCleanHTML.push(["removeSpecChar",true]) :  optionCleanHTML.push(["removeSpecChar",false]);
			(modal.element.find('input#removeConditional').prop('checked'))? optionCleanHTML.push(["removeConditional",true]) :  optionCleanHTML.push(["removeConditional",false]);
			(modal.element.find('input#removeComments').prop('checked'))? optionCleanHTML.push(["removeComments",true]) :  optionCleanHTML.push(["removeComments",false]);
			(modal.element.find('input#removeEmptyContainers').prop('checked'))? optionCleanHTML.push(["removeEmptyContainers",true]) :  optionCleanHTML.push(["removeEmptyContainers",false]);
			(modal.element.find('input#removeLang').prop('checked'))? optionCleanHTML.push(["removeLang",true]) :  optionCleanHTML.push(["removeLang",false]);
			(modal.element.find('input#removeDel').prop('checked'))? optionCleanHTML.push(["removeDel",true]) :  optionCleanHTML.push(["removeDel",false]);
			(modal.element.find('input#removeIns').prop('checked'))? optionCleanHTML.push(["removeIns",true]) :  optionCleanHTML.push(["removeIns",false]);
			(modal.element.find('input#removeXML').prop('checked'))? optionCleanHTML.push(["removeXML",true]) :  optionCleanHTML.push(["removeXML",false]);
			(modal.element.find('input#removeScripts').prop('checked'))? optionCleanHTML.push(["removeScripts",true]) :  optionCleanHTML.push(["removeScripts",false]);
			(modal.element.find('input#removeObjects').prop('checked'))? optionCleanHTML.push(["removeObjects",true]) :  optionCleanHTML.push(["removeObjects",false]);
			(modal.element.find('input#removeVideoAudio').prop('checked'))? optionCleanHTML.push(["removeVideoAudio",true]) :  optionCleanHTML.push(["removeVideoAudio",false]);
			(modal.element.find('input#removeEmptyP').prop('checked'))? optionCleanHTML.push(["removeEmptyP",true]) :  optionCleanHTML.push(["removeEmptyP",false]);
			(modal.element.find('input#convertP').prop('checked'))? optionCleanHTML.push(["convertP",true]) :  optionCleanHTML.push(["convertP",false]);
			(modal.element.find('input#removeStyles').prop('checked'))? optionCleanHTML.push(["removeStyles",true]) :  optionCleanHTML.push(["removeStyles",false]);
			(modal.element.find('input#removeClasses').prop('checked'))? optionCleanHTML.push(["removeClasses",true]) :  optionCleanHTML.push(["removeClasses",false]);
			(modal.element.find('input#removeFont').prop('checked'))? optionCleanHTML.push(["removeFont",true]) :  optionCleanHTML.push(["removeFont",false]);
			(modal.element.find('input#removeSpan').prop('checked'))? optionCleanHTML.push(["removeSpan",true]) :  optionCleanHTML.push(["removeSpan",false]);
			
			pasteCleanHtmlcode(modal.element.find('#contentPaste').html(),optionCleanHTML);
			 modal.hide();
			$(RVwys.currentIframe).focus();
		};
		var oncancel  = function(){
			modal.hide();
		};
		var options   = {
				bgclose:false, 
				keyboard:false, 
				modal:false,
				width:900
				};
		
		var modal = UI.modal.dialog(([
		                              '<div class="uk-margin uk-modal-header"><h2>'+rvLang('Paste from external')+'</h2><span class="uk-modal-close uk-icon-close"></span></div>',
		                              '<div class="uk-margin uk-modal-content">'+$('.dialogPasteExternal').html()+'</div>',
		                              '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">'+rvLang('Insert')+'</button>',
		                              '<button class="uk-button js-modal-confirm-cancel">'+rvLang('Cancel')+'</button></div>',
		                              ]).join(""), options);
		modal.element.find(".js-modal-confirm-cancel").on("click", function(){
			 oncancel();
			
		}).end().find(".uk-button-success").on("click", function(){
			onInsert();
			
		}).end().find('.uk-modal-dialog').addClass('uk-modal-dialog-large')
		modal.show();
		
		
	};
	jQuery.fn.removeAttributes = function() {
		return this.each(function() {
			var exceptAttr = ['src','href'];
			var attributes = $.map(this.attributes, function(item) {
				return item.name;
			});
			var img = $(this);
			$.each(attributes, function(i, item) {
				for(var numout = 0;numout < exceptAttr.length;numout++){
					if(item == exceptAttr[numout]){
						return;
					}
				}
				img.removeAttr(item);
			});
		});
	}
	function _removePMargins(str) {
		var b = str.replace(/(<[^>]* style=")([^"]*)("[^>]*>)/gi, "$1");
		var a = str.replace(/(<[^>]* style=")([^"]*)("[^>]*>)/gi, "$3");
		var str=str.replace(/(<[^>]* style=")([^"]*)("[^>]*>)/gi, "$2");
		str = str.replace(/url\([\s\S]*?\)/gi, function(x){return '[WP'+escape(x)+'WP]';});
		str = str.replace(/"[\s\S]*?"/g, function(x){return '[WP'+escape(x)+'WP]';});
		str = str.replace(/'[\s\S]*?'/g, function(x){return '[WP'+escape(x)+'WP]';});
		var arr = {};
		var styles = str.match(/([A-Za-z\-]*:[^;]*)/gi);
		if (styles) {
			var n = styles.length;
			for (var i=0; i<n; i++) {
				s = styles[i].split(':');
				if (s[0] && s[1]) {
					if (/^\s*(mso-|margin|padding)/.test(s[0])) continue;
					arr[s[0]] = s[1];
				}
			}
			var str = '';
			for (var key in arr) {
				var val = arr[key];
				if (!val) continue;
				str += key + ':'+val+'; ';
			}
			if (/; $/.test(str)) {
				str = str.substring(0, str.length - 2);
			}
		}
		str = str.replace(/\[WP[\s\S]*?WP\]/g, function(x){return unescape(x).replace(/\[WP/g, '').replace(/WP\]/g, '');});
		return b+str+a;
	}
	
	function cleanHtml(htmlCode) {

	    var readableHTML = htmlCode;
	    var lb = '\r\n';

	    var htags = ["<html", "</html>", "</head>", "<title", "</title>", "<meta", "<link", "<style", "</style>", "</body>"];
	    for (i = 0; i < htags.length; ++i) {
	        var hhh = htags[i];
	        readableHTML = readableHTML.replace(new RegExp(hhh, 'gi'), lb + hhh);
	    }

	    var btags = ["</div>", "</span>", "</form>", "</fieldset>", "<br>", "<br />", "<hr", "<pre", "</pre>", "<blockquote", "</blockquote>", "<ul", "</ul>", "<ol", "</ol>", "<li", "<dl", "</dl>", "<dt", "</dt>", "<dd", "</dd>", "<\!--", "<table", "</table>", "<caption", "</caption>", "<th", "</th>", "<tr", "</tr>", "<td", "</td>", "<script", "</script>", "<noscript", "</noscript>"];
	    for (i = 0; i < btags.length; ++i) {
	        var bbb = btags[i];
	        readableHTML = readableHTML.replace(new RegExp(bbb, 'gi'), lb + bbb);
	    }

	    var ftags = ["<label", "</label>", "<legend", "</legend>", "<object", "</object>", "<embed", "</embed>", "<select", "</select>", "<option", "<option", "<input", "<textarea", "</textarea>"];
	    for (i = 0; i < ftags.length; ++i) {
	        var fff = ftags[i];
	        readableHTML = readableHTML.replace(new RegExp(fff, 'gi'), lb + fff);
	    }

	    var xtags = ["<body", "<head", "<div", "<span", "<p", "<form", "<fieldset"];
	    for (i = 0; i < xtags.length; ++i) {
	        var xxx = xtags[i];
	        readableHTML = readableHTML.replace(new RegExp(xxx, 'gi'), lb + lb + xxx);
	    }
	    //document.getElementById("newCode").value = readableHTML;
	    return readableHTML;
	}
	var pasteExternal;


	
	$(document).on('editorReady',function(){
		$('#pasteFromExternal').click(function(){
			RVwys.windowPasteFromExternal(false);
		});
		window.pasteCleanHtmlcode = function (pasteHtmlcode,optionCleanHTML) {
			var incre;
			for(incre = 0;incre< optionCleanHTML.length; incre++){
				switch(optionCleanHTML[incre][0]){
				case 'removeProprietary':
					if(optionCleanHTML[incre][1]) {
						while (pasteHtmlcode.match(/(<[^>]+) _[a-z:\-_]=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi)) {
							pasteHtmlcode = pasteHtmlcode.replace(/(<[^>]+) _[a-z:\-_]=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi, '$1');
						}
					}
					break;
				case 'removeSpecChar':
					if(optionCleanHTML[incre][1]) {
						var t = {}
						t[130] = 8218;
						t[131] = 402;
						t[132] = 8222;
						t[133] = 8230;
						t[134] = 8224;
						t[135] = 8225;
						t[136] = 710;
						t[137] = 8240;
						t[138] = 352;
						t[139] = 8249;
						t[140] = 338;
						t[145] = 8216;
						t[146] = 8217;
						t[147] = 8220;
						t[148] = 8221;
						t[149] = 8226;
						t[150] = 8211;
						t[151] = 8212;
						t[152] = 732;
						t[153] = 8482;
						t[154] = 353;
						t[155] = 8250;
						t[156] = 339;
						t[159] = 376;
						var arr = [];
						var n = pasteHtmlcode.length;
						for (var j=0; j<n; j++) {
							
							var charCode = pasteHtmlcode.charCodeAt(j);
							if (t[charCode]) {
								arr.push(charCode);
							}
						}
						var n = arr.length;
						for (var j=0; j<n; j++) {
							pasteHtmlcode = pasteHtmlcode.replace(String.fromCharCode(arr[j]), (t[arr[j]]?"&#"+t[arr[j]]+";":"&#"+arr[j]+";"))
						}
					}
					break;

				case 'removeConditional':
					if(optionCleanHTML[incre][1]) {
						while (pasteHtmlcode.match(/<![\-]*\[if [^\]]*\][\-]*>([\s\S]*?)<![\-]*\[endif\][\-]*>/gi)) {
							pasteHtmlcode = pasteHtmlcode.replace(/<![\-]*\[if [^\]]*\][\-]*>([\s\S]*?)<![\-]*\[endif\][\-]*>/gi, '');
						}
					}
					break;
				case 'removeComments':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/<!--([\s\S]*?)-->/gi, '');
					}
					break;
				case 'removeEmptyContainers':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/(<p(| [^>]*)><\/p>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/(<h[0-9](| [^>]*)><\/h[0-9]>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/(<div(| [^>]*)><\/div>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/(<span(| [^>]*)><\/span>)/gi, '');
					}
					break;
				case 'removeLang':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/(<[a-z0-9]+[^>]*) lang=("[^>"]*"|'[^>']*'|[a-z0-9\-_][^> ]*)/gi, '$1');
					}
					break;
				case 'removeDel':
					if(optionCleanHTML[incre][1]) {
						while (pasteHtmlcode.match(/<del(| [^>]*)>([\s\S]*?)<\/del>/gi)) {
							pasteHtmlcode = pasteHtmlcode.replace(/<del[^>]*>([\s\S]*?)<\/del>/gi, '');
						}
					}
					break;
				case 'removeIns':
					if(optionCleanHTML[incre][1]) {
						while (pasteHtmlcode.match(/<ins(| [^>]*)>([\s\S]*?)<\/ins>/gi)) {
							pasteHtmlcode = pasteHtmlcode.replace(/<ins(| [^>]*)>([\s\S]*?)<\/ins>/gi, '$2');
						}
					}
					break;
				case 'removeXML':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/<\?xml(|:[^>]*| [^>]*)>/gi, '');
						while (pasteHtmlcode.match(/<[^>]+ [a-z0-9.\-_]+:[a-z0-9.\-_]+=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi)) {
							pasteHtmlcode = pasteHtmlcode.replace(/(<[^>]+) [a-z0-9.\-_]+:[a-z0-9.\-_]+=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi, '$1')
						}
						pasteHtmlcode = pasteHtmlcode.replace(/<[a-z0-9.\-_]+:[a-z0-9.\-_]+[^>]*>/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<\/[a-z0-9.\-_]+:[a-z0-9.\-_]+[^>]*>/gi, '');
					}
					break;
				case 'removeScripts':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/<script(| [^>]*)>([\s\S]*?)<\/script>/gi, '');
						while (pasteHtmlcode.match(/<[^>]+ on[a-zA-Z]+=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi)) {
							pasteHtmlcode = pasteHtmlcode.replace(/(<[^>]+) on[a-zA-Z]+=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi, '$1')
						}
					}
					break;
				case 'removeObjects':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/<object(| [^>]*)>([\s\S]*?)<\/object>/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<embed(| [^>]*)>([\s\S]*?)<\/embed>/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<applet(| [^>]*)>([\s\S]*?)<\/applet>/gi, '');
					}
					break;
				case 'removeVideoAudio':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/<video(| [^>]*)>([\s\S]*?)<\/video>/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<audio(| [^>]*)>([\s\S]*?)<\/audio>/gi, '');
					}
					break;
				case 'removeEmptyP':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/(<p(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/p>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<p [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
						pasteHtmlcode = pasteHtmlcode.replace(/(<h1(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/h1>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<h1 [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
						pasteHtmlcode = pasteHtmlcode.replace(/(<h2(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/h2>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<h2 [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
						pasteHtmlcode = pasteHtmlcode.replace(/(<h3(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/h3>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<h3 [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
						pasteHtmlcode = pasteHtmlcode.replace(/(<h4(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/h4>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<h4 [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
						pasteHtmlcode = pasteHtmlcode.replace(/(<h5(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/h5>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<h5 [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
						pasteHtmlcode = pasteHtmlcode.replace(/(<h6(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/h6>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<h6 [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
						pasteHtmlcode = pasteHtmlcode.replace(/(<h7(| [^>]*)>(|<(strong|b|em|i)[^>]*>)(\xA0|\s+|&nbsp;|)(|<\/(strong|b|em|i)>)<\/h7>)/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<h7 [^>]*style="[^"]*"[^>]*>/gi, _removePMargins);
					}
					break;
				case 'convertP':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/(<p(| [^>]*)>([\s\S]*?)<\/p>)/gi, '<div$2>$3</div>');
					}
					break;

				case 'removeStyles':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/(<[^>]+) style=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi, '$1');
					}
					break;

				case 'removeClasses':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/(<[^>]+) class=("[^"]*"|'[^']*'|[a-z0-9\-_][^> ]*)/gi, '$1');
					}
					break;

				case 'removeFont':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/<font(| [^>]*)>/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<\/font>/gi, '');
					}
					break;

				case 'removeSpan':
					if(optionCleanHTML[incre][1]) {
						pasteHtmlcode = pasteHtmlcode.replace(/<span(| [^>]*)>/gi, '');
						pasteHtmlcode = pasteHtmlcode.replace(/<\/span>/gi, '');
					}
					break;
				}
			}
			var unCompressHtmlCode = cleanHtml(pasteHtmlcode);
			var wrapPasteHtml = '<div id="pasteElement">'+unCompressHtmlCode+'</div>';
			RVwys.insertHTML(wrapPasteHtml);
			
			$('#frameBody').find('#pasteElement').contents().unwrap();
		}
	});	
}) (jQuery);
